import React, {ReactNode} from 'react';
import {toSnakeCase} from "services/string";

type RadioItem = {
    id: number
    name: string
    description?: string | ReactNode
}

type Props = {
    label: string
    items: Array<RadioItem>
    selectedId: number|null|undefined
    onChange: (selectedId: number) => any
}

function RadioGroup({label, items, selectedId, onChange}: Props) {
    return (
        <fieldset className="mt-4">
            <legend className="sr-only">{label}</legend>
            <div className="space-y-4">
                {items.map((item) => (
                  <div key={item.id} className="flex flex-col gap-1">
                    <div className="flex items-center">
                        <input
                            id={item.id.toString()}
                            name={toSnakeCase(label, '-')}
                            type="radio"
                            defaultChecked={item.id === selectedId}
                            className="focus-visible:ring-brand focus-visible:ring-1 focus:ring-0 focus:outline-none h-4 w-4 text-brand border-gray-300"
                            onChange={() => onChange(item.id)}
                        />
                        <label htmlFor={item.id.toString()} className="ml-3 block text-sm font-medium text-gray-700">
                            {item.name}
                        </label>
                    </div>
                    {(item.description && typeof item.description === 'string') && <p className="text-xs text-gray-500 pl-7">{item.description}</p>}
                    {(item.description && typeof item.description !== 'string') && item.description}
                  </div>
                ))}
            </div>
        </fieldset>
    );
}

RadioGroup.defaultProps = {
    onChange: () => null
}

export default RadioGroup;